export default {
	updateOrgTransferInvoice(state, res) {
		state.OrganizationTransferInvoice = res;
	},
	updateOrgTransferInvoices(state, res) {
		state.OrganizationTransferInvoices = res;
	},
	updateTotalPage(state, res) {
		state.Total = res;
	},
	updateIsLoadingData(state, res) {
		state.IsLoadingData = res;
	},
};
